import logo1 from "../../assets/images/partners/kwpwroclaw.png";
import logo2 from "../../assets/images/partners/mgi.png";
import logo3 from "../../assets/images/partners/my-medikal.png";
import logo4 from "../../assets/images/partners/Poczta-polska_logo.png";
import logo5 from "../../assets/images/partners/policja.png";
import logo6 from "../../assets/images/partners/szpital.png";

const partnersLogos = [
  {
    logo: logo1,
    alt: "Komenda Wojewódzka Policji w Wrocławiu",
  }, {
    logo: logo2,
    alt: "MGI Medical",
  }, {
    logo: logo3,
    alt: "My Medikal",
  }, {
    logo: logo4,
    alt: "Poczta Polska",
  }, {
    logo: logo5,
    alt: "Komenda Główna Policji w Krakowie",
  }, {
    logo: logo6,
    alt: "Szpital Pediatryczny w Bielsku Białej",
  },
];

export { partnersLogos };